import React from 'react';
import { Breadcrumb, BreadcrumbItem } from 'reactstrap';
import { AppState } from '@Redux/store';
import { Dispatch } from '@Redux/type';
import { connect } from 'react-redux';
import { container } from '@Container';
import { TYPES } from '@Types';
import { armyListUnitPresenter } from '@Selectors/builder/myArmyList/common/armyListUnitPresenter';
import ArmyListUnitShowV1 from '@Builder/myArmyList/make/unit/ArmyListUnitShowV1';
import ArmyListUnitShowV2 from '@Builder/myArmyList/make/unit/ArmyListUnitShowV2';
import { Link, useParams } from 'react-router-dom';
import { ArmyListUnitAction } from '@Redux/actions';
import ArmyListUnitShowV3 from '@Builder/myArmyList/make/unit/ArmyListUnitShowV3';

const ArmyListUnitPageShow: React.FC<BuilderArmyListUnitAppProps> = ({
                                                                       armyListUnit,
                                                                       loadArmyListUnit
                                                                     }) => {
  const params = useParams();
  const armyListUnitId = params.army_list_unit_id;

  if (!armyListUnitId) {
    return <div>
      Army List Unit not found!
    </div>
  }
  React.useEffect(() => {
    loadArmyListUnit(armyListUnitId);
  }, []);

  return <div>
    <div className="army_list row">
    </div>

    <Breadcrumb>
      <BreadcrumbItem>
        <Link to={`/${document.documentElement.lang}/builder/army_lists`}>
          <i className="fa-solid fa-house"></i>
        </Link>
      </BreadcrumbItem>
      <BreadcrumbItem active>{armyListUnit.name}</BreadcrumbItem>
    </Breadcrumb>

    <div>
      {armyListUnit.showV1 && <ArmyListUnitShowV1 armyListUnitId={armyListUnit.id!}/>}
      {armyListUnit.showV2 && <ArmyListUnitShowV2 armyListUnitId={armyListUnit.id!}/>}
      {armyListUnit.showV3 && <ArmyListUnitShowV3 armyListUnitId={armyListUnit.id!}/>}
    </div>
  </div>;
};

const mapStateToProps = (state: AppState) => ({
  armyListUnit: armyListUnitPresenter(state),
});

const mapDispatchToProps = (dispatch: Dispatch) => {
  const armyListUnitAction = container.get<ArmyListUnitAction>(TYPES.Actions.ArmyListUnitAction);

  return {
    loadArmyListUnit: (id: string) => dispatch(armyListUnitAction.fetchData({entityId: id})),
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(ArmyListUnitPageShow);

type BuilderArmyListUnitAppProps = ReturnType<typeof mapDispatchToProps> &
  ReturnType<typeof mapStateToProps>
